import { DropdownButtonType, List, SearchFieldProps, SearchFieldWidget, SingleSelectDropdown, SingleSelectDropdownProps } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../CommonStyles';
import { IReactTranslateService } from '../IReactTranslateService';

export class SiteMembershipFilters extends React.PureComponent<SiteMembershipFiltersProps> {
  public render() {
    let membershipSearchProps: SearchFieldProps = this.createMembershipSearchProps();
    let membershipSelectProps: SingleSelectDropdownProps = this.createMembershipSelectDropdownProps();

    return (
      <div style={{ display: 'flex' }}>
        <span style={{ width: 150, flexShrink: 0, marginRight: CommonStyles.Sizes.DefaultSpace }}><SingleSelectDropdown {...membershipSelectProps} /></span>
        <span style={{ flexGrow: 1 }}><SearchFieldWidget {...membershipSearchProps} /></span>
      </div>
    );
  }

  public createMembershipSelectDropdownProps(): SingleSelectDropdownProps {
    return {
      value: this.props.siteFilterSelection,
      onChange: this.props.onFilterSelected,
      type: DropdownButtonType.Outline,
      testId: 'site-membership-select-DropdownButton',
      list: <List items={this.props.filters.map(value => ({
        value,
        content: this.props.translate(value),
        testId: ['site-membership-select', value, 'MenuItem'].join('-'), // for compatibility with existing automation test
      }))} />,
      label: null, // FIXME needs aria-label to be accessible TFSID 1227748
    };
  }

  public createMembershipSearchProps() {
    let membershipSearchProps: SearchFieldProps = {
      handleChange: this.props.onSearchInputTextChange,
      handleCancelSearch: this.props.onCancelSearch,
      placeholder: Messages.searchSites(),
      testId: 'site-membership-search',
      text: this.props.searchInputText,
    };
    return membershipSearchProps;
  }
}

export interface SiteMembershipFiltersProps {
  readonly filters: string[];
  readonly onFilterSelected: (value: string) => void;
  readonly siteFilterSelection: string;
  readonly onCancelSearch: () => void;
  readonly onSearchInputTextChange: (value: string) => void;
  readonly searchInputText?: string;
  translate: IReactTranslateService;
}
